import logger from "../utils/logger";
import React from "react";

export default class PageErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ errorInfo });
    logger.error("[PageErrorBoundary]", error, errorInfo);
  }

  componentDidUpdate(prevProps) {
    // Reset error when the route changes so the user can navigate away
    if (this.props.routeKey !== prevProps.routeKey && this.state.error) {
      this.setState({ error: null, errorInfo: null });
    }
  }

  render() {
    if (this.state.error) {
      return (
        <div className="p-[24px] max-w-[800px] mx-auto mt-[40px]">
          <div className="bg-red-500/10 border border-red-500/30 rounded-[12px] p-[24px]">
            <h2 className="text-red-400 text-[18px] font-semibold mb-[12px]">
              This page failed to load
            </h2>
            <div className="bg-[#0B0415] rounded-[8px] p-[16px] mb-[16px]">
              <p className="text-red-300 text-[14px] font-mono break-all">
                {this.state.error.toString()}
              </p>
            </div>
            {this.state.errorInfo?.componentStack && (
              <details className="mb-[16px]">
                <summary className="text-neutral-400 text-[13px] cursor-pointer hover:text-neutral-200">
                  Component stack trace
                </summary>
                <pre className="mt-[8px] bg-[#0B0415] rounded-[8px] p-[16px] text-[12px] text-neutral-400 font-mono overflow-x-auto whitespace-pre-wrap max-h-[300px] overflow-y-auto">
                  {this.state.errorInfo.componentStack}
                </pre>
              </details>
            )}
            <button
              onClick={() => this.setState({ error: null, errorInfo: null })}
              className="bg-[#7721E5] hover:bg-[#8B3BF0] text-white font-medium rounded-[8px] py-[8px] px-[16px] text-[13px] transition-colors"
            >
              Try again
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
